export const noop = (...args: Array<any>) => undefined;
